export default __webpack_public_path__ + "static/media/green-bag-active.db6e68ee.png";